import {
  fetchAccountInfo,
  fetchExpirationIsComing,
  fetchMyRewardList,
  fetchRedPacketTotalInfo,
  fetchTabList,
  Tab,
} from "@/api/daily-reward";
import { addLiveAddress, queryUserLiveRecords } from "@/api/live";
import {
  bizInfoParams,
  carrierContextParams,
  CarrierElementType,
  ContentType,
  envContextParams,
  SourceScene,
} from "@/api/scode/scode_params";
import { CustomEditData } from "@/components/poster-swiper";
import {
  AccountInfo,
  AwardItem,
  AwardProductItme,
  CouponAward,
  ExpirationIsComing,
  LiveLotteryItem,
  RedPackageAward,
} from "@/models/reward";
import { useCommonContext } from "@/utils/context/common";
import { getPlatform, MICRO_APP_BASEURL, platform } from "@/utils/platform";
import { useShare } from "@/utils/share/share";
import { getUrlParam } from "@/utils/url-parse";
import useNavigation from "@/utils/useNavigate";
import AKJS from "@akc/akjs";
import { useEffect, useRef, useState } from "react";
import { useActivate } from "react-activation";
import { useSearchParams } from "react-router-dom";
import useAddress from "../hook/useAddress";
import { couponTrack, pageView, pointTrack, redPacketTrack } from "../track/reward";
import usePageAction, { liveTabsList } from "../utils/action";
import useCouponAction from "../utils/coupon";

const { isSaas, isMini } = getPlatform();

let sharePosterData: any = null;
const useMyReward = () => {
  const commonContext = useCommonContext();
  const {
    openOrderDetail,
    openCustomerReward,
    openRedDetail,
    openRedPacketUsePage,
    openShopDetail,
    openVenue,
    openTopList,
  } = usePageAction();
  const [list, setList] = useState<AwardItem[]>([]);
  const pageIndex = useRef<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [redPacket, setRedPacket] = useState<AccountInfo>();
  const [expirationIsComing, setExpirationIsComing] = useState<ExpirationIsComing>(
    {} as ExpirationIsComing,
  );
  const [tabList, setTabList] = useState<Tab[]>();
  const currentRoleIsC = commonContext.currentRole === "C";
  const currentRoleIsAdmin = commonContext.currentRole === "A";
  const [selectTab, setSelectTab] = useState<Tab>();
  const [searchParams] = useSearchParams();
  const [showPoster, setShowPoster] = useState(false);
  const promoActivityId = searchParams.get("promoActivityId") ?? "";
  const [customEditData, setCustomEditData] = useState<CustomEditData>({} as CustomEditData);
  const { couponDetailAction } = useCouponAction();
  const drawResultInfo = useRef<AwardProductItme>();
  const [drawResultVisible, setDrawResultVisible] = useState(false);
  const [curShareType, setCurShareType] = useState(ContentType.dailyReward);
  const [totalAmount, setTotalAmount] = useState<number>(-1);
  const rewardTabs = ["日日奖", "直播间奖励"];
  const [selectRewardTab, setSelectRewardTab] = useState(0);
  const dailyTabsArr = useRef<Tab[]>([]); // 日日奖tab
  // 直播间tab
  const liveTabsArr = useRef<Tab[]>(liveTabsList);
  const rightTitle = "顾客奖励";

  const { navigate2H5, navigate } = useNavigation();

  const { shareDailyReward } = useShare();

  const formatResult = (res: any) => {
    return {
      currentPageSize: res?.currentSize || 10,
      extra: null,
      hasNext: res?.hasNext || res?.currentPage < res?.totalPage,
      pageIndex: res?.currentPage,
      pageSize: res?.currentSize,
      pages: res?.totalPage,
      result: res?.list || [],
      total: res?.totalSize,
      totalCount: res?.totalSize,
    };
  };
  const updateList = async (isSelect?: boolean) => {
    setLoading(true);
    if (selectTab?.type === undefined) {
      return;
    }
    let res: any = null;
    if (selectRewardTab === 0) {
      res = await fetchMyRewardList({
        awardType: selectTab?.type,
        pageIndex: pageIndex.current,
        pageSize: 10,
      });
    } else {
      res = await queryUserLiveRecords({
        queryStatus: Number(selectTab?.type),
        pageNum: pageIndex.current,
        pageSize: 10,
      });
      res = formatResult(res);
    }
    setLoading(false);
    if (!res) {
      return;
    }
    pageIndex.current = (res?.pageIndex ?? 0) + 1;
    if (isSelect) {
      setList(res?.result || []);
    } else {
      setList([...list, ...(res?.result || [])]);
    }
    setHasMore(res?.hasNext ?? false);
  };

  const updateRedPacketAmount = async () => {
    fetchAccountInfo().then(res => {
      if (res?.freeBalance !== undefined) {
        setRedPacket(res);
      }
    });
  };

  const updateTotalAmount = async () => {
    fetchRedPacketTotalInfo().then(res => {
      if (res?.totalInAmount !== undefined) {
        if (res?.totalInAmount) {
          setTotalAmount(res?.totalInAmount);
        }
      }
    });
  };

  const getExpirationIsComing = () => {
    fetchExpirationIsComing().then(res => {
      setExpirationIsComing(res);
    });
  };

  const loadMore = async () => {
    if (hasMore && !loading) {
      updateList();
    }
  };

  useEffect(() => {
    const arr = selectRewardTab === 0 ? dailyTabsArr.current : liveTabsArr.current;
    setList([]);
    pageIndex.current = 1;
    if (arr?.length > 0) {
      setTabList(arr);
      setSelectTab(arr[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRewardTab]);

  const updateTabList = () => {
    fetchTabList().then(res => {
      if (res !== undefined) {
        dailyTabsArr.current = res;

        setTabList(res);
        if (res?.[0] !== undefined) {
          setSelectTab(res?.[0]);
        }
      }
    });
  };

  useEffect(() => {
    document.title = "我的奖励";
    updateTabList();
    updateRedPacketAmount();
    updateTotalAmount();
    getExpirationIsComing();
    pageView(promoActivityId);
  }, []);

  useEffect(() => {
    pageIndex.current = 1;
    updateList(true);
  }, [selectTab]);

  useActivate(() => {
    updateRedPacketAmount();
    document.title = "我的奖励";
  });

  (window as any).akc_onAppear = () => {
    updateRedPacketAmount();
  };

  const scrollToTop = () => {
    const dom = document?.getElementById("page");
    if (dom) {
      dom.scrollTop = 0;
    }
  };

  const onChangeTabIndex = (e, index: number) => {
    e.stopPropagation();
    setSelectTab(tabList?.[index]);
    scrollToTop();
  };

  // 店铺
  const shopDetail = (redPacket?: RedPackageAward) => openShopDetail(redPacket?.merchantShopCode);

  // 实物奖去店铺
  const onShopDetailAction = (reward?: AwardItem) =>
    openShopDetail(reward?.productAward?.merchantShopCode);

  // 商家券跳店铺
  const onCouponToShopDetailAction = (coupon?: CouponAward) =>
    openShopDetail(coupon?.merchantShopCode);

  // 优惠券凑单页
  const shareableCouponDetail = async (couponAward?: CouponAward) => {
    couponDetailAction(couponAward);
  };

  const onUseAction = (reward?: AwardItem, index?: number) => {
    // 去店铺
    if (reward?.awardType === "RED_PACKET") {
      if (reward?.redPackageAward?.customPageCode) {
        openVenue(reward?.redPackageAward);
      } else {
        shopDetail(reward?.redPackageAward);
        redPacketTrack(false, index);
      }
      return;
    }

    // 优惠去凑单页
    if (reward?.awardType === "COUPON") {
      shareableCouponDetail(reward?.couponAward);
      couponTrack(reward?.couponAward?.couponTemplateId, index);
      return;
    }

    // 去C的会员中心页面
    if (reward?.awardType === "POINTS") {
      openTopList();
      pointTrack(index);
      return;
    }
  };

  // 顾客奖励
  const onRightAction = () => {
    openCustomerReward(promoActivityId);
  };

  // 转发
  const onForwardAction = () => {
    if (platform.isH5) {
      sharePosterData = {
        bizInfo: bizInfoParams({
          contentType: ContentType.dailyReward,
          contentId: promoActivityId,
        }),
        envContext: envContextParams({
          sourceScene: SourceScene.dailyReward,
          sourceSceneId: ContentType.dailyReward,
        }),
        carrierContext: carrierContextParams([CarrierElementType.h5Poster]),
      };
      setCustomEditData({
        promoActivityId: promoActivityId,
      });
      setCurShareType(ContentType.dailyReward);
      setShowPoster(true);
    } else {
      const params = {
        contentId: promoActivityId ?? "",
        shareType: SourceScene.dailyReward,
      };
      shareDailyReward(params);
    }
  };

  // 红包详情
  const onRedDetailAction = () => openRedDetail();

  // 红包凑单
  const onRedPacketUseAction = (isUse?: boolean) => {
    openRedPacketUsePage(isUse);
    redPacketTrack(true, 0);
  };

  // 关闭转发
  const onClosePosterAction = () => {
    setShowPoster(false);
  };

  // 去领取
  const onClaimRewardAction = (reward?: AwardItem) => {
    drawResultInfo.current = {
      ...reward,
      productType: reward?.productType ?? reward?.productAward?.productType, // 首页和我的奖励传递的值类型不一样，兼容处理
      activitySpuId: reward?.productAward?.activitySpuId,
      lotteryActivityId: reward?.promoTaskId,
      lotteryAwardResultId: reward?.recordId,
    };
    setDrawResultVisible(true);
  };

  const handleAddress = (lottery?: LiveLotteryItem, addressId?: string) => {
    addLiveAddress({
      addressId,
      liveNo: lottery?.liveNo,
      rewardId: lottery?.rewardId,
    }).then(res => {
      console.log("地址信息", res);
      if (selectRewardTab === 1) {
        setList([]);
        pageIndex.current = 1;
        updateList(true);
      }
    });
  };

  const onAddressAction = (lottery?: LiveLotteryItem) => {
    const { shopId, actId, contentId, addressOnlyId } = getUrlParam() || {};
    const query = {
      shopId,
      fromPage: "reward",
      actId: actId || contentId,
      addressOnlyId,
      liveNo: lottery?.liveNo,
      rewardId: lottery?.rewardId,
      rewardName: lottery?.awardName,
    };

    if (platform.isApp) {
      AKJS.ready().then(() => {
        AKJS.action
          .dispatch("event.info.chooseAddress", { addressId: "" })
          .then(result => {
            if (result?.data?.addressId) {
              const addressId = result?.data?.addressId;
              console.log("地址信息event.info.chooseAddress", addressId);
              handleAddress(lottery, addressId);
            }
          })
          .catch(err => {
            console.log("err: ", err);
          });
      });
    } else {
      setTimeout(() => {
        navigate({
          h5Options: {
            url: `${MICRO_APP_BASEURL}/#/addressList`,
            query,
          },
          type: undefined,
          replace: false,
          miniOptions: {
            url: "/mePkg/pages/address/address",
            query,
          },
        });
      }, 100);
    }
  };

  // 订单详情
  const onOrderDetailAction = (reward?: AwardItem) => {
    openOrderDetail(reward);
  };

  // 关闭领奖pop
  const onCloseDrowResultPopAction = () => setDrawResultVisible(false);

  // 实物奖列表刷新
  const onProductRefreshAction = () => {
    if (selectTab?.type === "PRODUCT") {
      pageIndex.current = 1;
      scrollToTop();
      updateList(true);
    }
  };

  // 刷新红包总额
  const onRefreshTotalAmountAction = () => updateTotalAmount();

  const rewardName = (reward?: AwardItem) => {
    if (reward?.awardType === "RED_PACKET") {
      return reward?.redPackageAward?.amount;
    }
    if (reward?.awardType === "COUPON") {
      return reward?.couponAward?.couponName;
    }
    if (reward?.awardType === "POINTS") {
      return reward?.pointsAward?.amount;
    }
    if (reward?.awardType === "PRODUCT") {
      return reward?.productAward?.activitySpuId;
    }
  };

  // 日日奖清单转发
  const onRewardForwardAction = (reward?: AwardItem) => {
    if (platform.isH5) {
      sharePosterData = {
        bizInfo: bizInfoParams({
          contentType: ContentType.dailyRewardGift,
          contentId: promoActivityId,
          contentDetailId: reward?.userId,
          extra: {
            awardName: rewardName(reward),
            awardType: reward?.awardType,
          },
        }),
        envContext: envContextParams({
          sourceScene: SourceScene.dailyRewardGift,
          sourceSceneId: ContentType.dailyRewardGift,
        }),
        contentContext: {
          awardType: reward?.awardType,
        },
        carrierContext: {
          ...carrierContextParams([CarrierElementType.h5Poster]),
          posterCode: ContentType.dailyRewardGift,
        },
      };
      setCustomEditData({
        promoActivityId: promoActivityId,
        awardName: reward && rewardName(reward),
        awardType: reward?.awardType,
      });
      setCurShareType(ContentType.dailyRewardGift);
      setShowPoster(true);
    } else {
      const params = {
        contentId: promoActivityId,
        shareType: SourceScene.dailyRewardGift,
        contentDetailId: reward?.userId,
        awardName: rewardName(reward),
        awardType: reward?.awardType,
      };
      shareDailyReward(params);
    }
  };

  const emptyTitleDes = (tab?: Tab) => {
    if (tab?.type === "PRODUCT") {
      return "暂无相关可用的实物奖励";
    }
    if (tab?.type === "RED_PACKET") {
      return "暂无相关可用的红包";
    }
    if (tab?.type === "COUPON") {
      return "暂无相关可用的优惠券";
    }

    if (tab?.type === "POINTS") {
      return "暂无相关可用的积分";
    }
  };

  return {
    canShare: !commonContext.isExternal,
    tabList,
    selectTab,
    rightTitle,
    list,
    redPacket,
    loading,
    hasMore,
    currentRoleIsC,
    currentRoleIsAdmin,
    showPoster,
    sharePosterData,
    customEditData,
    drawResultVisible,
    drawResultInfo,
    curShareType,
    totalAmount,
    expirationIsComing,
    onCloseDrowResultPopAction,
    onProductRefreshAction,
    loadMore,
    onChangeTabIndex,
    emptyTitleDes,
    onForwardAction,
    onRightAction,
    onRedDetailAction,
    onUseAction,
    onClosePosterAction,
    onRedPacketUseAction,
    onClaimRewardAction,
    onOrderDetailAction,
    onShopDetailAction,
    onCouponToShopDetailAction,
    onRewardForwardAction,
    onRefreshTotalAmountAction,
    setSelectTab,
    rewardTabs,
    selectRewardTab,
    setSelectRewardTab,
    onAddressAction,
  };
};

export default useMyReward;
